import React, { useEffect, useContext } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { FiShoppingCart } from "react-icons/fi";
import { BsChatLeft } from "react-icons/bs";
import { RiNotification3Line } from "react-icons/ri";
import { MdKeyboardArrowDown } from "react-icons/md";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import StateContext from "../contexts/ContextProvider";
import avatar from "../assets/avatar.jpg";
import { Cart, Chat, Notification, UserProfile } from ".";
import { useStateContext } from "../contexts/ContextProvider";
import axios from "axios";
import UserProfileNew from "./UserProfileNew";
import { Tooltip } from "@material-ui/core";

const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ color }}
      className="relative text-xl rounded-full p-3 hover:bg-light-gray"
    >
      <span
        style={{ background: dotColor }}
        className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
      />
      {icon}
    </button>
  </TooltipComponent>
);

const Navbar = () => {
  const {
    currentColor,
    activeMenu,
    setActiveMenu,
    handleClick,
    isClicked,
    setScreenSize,
    screenSize,
    profileData,
    setProfileData,
    token,
    setPincod,
  } = useStateContext();

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (screenSize <= 900) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }, [screenSize, profileData]);

  useEffect(() => {
    if (token) {
      fetchProfile();
    }
  }, [token]);

  function fetchProfile() {
    const headers = {
      "x-token": token,
    };
    const getProfileAPI = "https://api.orbitmart.co.in/api/v1/auth/get-profile";
    axios
      .get(getProfileAPI, { headers })
      .then((res) => {
        console.log(res.data);
        console.log(res.data.data);
        setProfileData(res.data.data);
        setPincod(res.data.data.pincode);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }

  const handleActiveMenu = () => setActiveMenu(!activeMenu);
  console.log(isClicked.userProfile,"fesfd")
  const handleUserProfile = () => {
    <UserProfileNew open={true} />
  }

  return (
    <div className="flex justify-between p-2 md:ml-6 md:mr-6 relative">
      <NavButton
        title="Menu"
        customFunc={handleActiveMenu}
        color={currentColor}
        icon={<AiOutlineMenu />}
      />
      <div className="flex">
        <Tooltip content="Profile" position="BottomCenter" onClick={handleUserProfile}>
          <div
            className="flex items-center gap-2 cursor-pointer p-1 hover:bg-light-gray rounded-lg"
            onClick={() => handleClick("userProfile")}
          >
            <img
             style={{ width: 50 ,
              height: 50,
              borderRadius: 50 / 2,
              overflow: "hidden",
              borderWidth: 2,
              borderColor: "rgb(158, 235, 71)", objectFit:'cover'}}

              className="rounded-full w-8 h-8"
              src={profileData?.avatar}
              alt="user"
            />
            <p>
              <span className="text-gray-400 text-14">Hi,</span>{" "}
              <span className="text-gray-400 font-bold ml-1 text-14">
                {profileData?.firmName}
              </span>
            </p>
            <MdKeyboardArrowDown className="text-gray-400 text-14" />
          </div>
        </Tooltip>
        {isClicked.userProfile && <UserProfile open={true} />}
      </div>
    </div>
  );
};

export default Navbar;
